import store from '../store';
import { Envs } from '../service/types';

export const envMap = {
  '1': Envs.DEV,
  '2': Envs.TEST,
  '3': Envs.RELEASE,
  '4': Envs.PRO
}

export const FastEnvMap = {
  [Envs.DEV]: 'dev',
  [Envs.TEST]: 'test',
  [Envs.RELEASE]: 'beta',
  [Envs.PRO]: 'prod',
}

export const ENV = (): Envs => {
  const yunkeEnv = process.env.YUNKE_ENV as Envs;
  return store.env || yunkeEnv || Envs.PRO;
}

export enum TenantOrgCodes {
  default = 'default',
  jdjituanadmin = 'jdjituanadmin'
}

export const tenantConfig = {
  [TenantOrgCodes.default]: {
    name: '公共环境',
    serverHost: {
      [Envs.DEV]: 'http://127.0.0.1:48315/api/v1',
      [Envs.TEST]: 'https://gateway-test.myscrm.cn/bff-xsdj-app/api/v1',
      [Envs.RELEASE]: 'https://gateway-release.myscrm.cn/bff-xsdj-app/api/v1',
      [Envs.PRO]: 'https://gateway.myscrm.cn/bff-xsdj-app/api/v1',
    },
  },
  [TenantOrgCodes.jdjituanadmin]: {
    name: '金地环境',
    serverHost: {
      [Envs.DEV]: 'https://myscrm-test-gateway.gemdale.com/bff-xsdj-app/api/v1',
      [Envs.TEST]: 'https://myscrm-test-gateway.gemdale.com/bff-xsdj-app/api/v1',
      [Envs.RELEASE]: 'https://myscrm-gateway.gemdale.com/bff-xsdj-app/api/v1',
      [Envs.PRO]: 'https://myscrm-gateway.gemdale.com/bff-xsdj-app/api/v1',
    },
  },
};

const getTenant = (orgCode?: string) => {
  if (orgCode && Object.keys(tenantConfig).includes(orgCode)) {
    return orgCode as TenantOrgCodes;
  }
  return TenantOrgCodes.default;
};

export const getServerHost = (orgCode?: string): string => {
  const tenant = getTenant(orgCode);
  return tenantConfig[tenant].serverHost[ENV()];
};


export const homepage = (function (): Envs {
  const packageJson = require('../../package.json');
  return packageJson.homepage;
}());

